import { useQuery } from 'react-query'
import { getBlockingSubscriptionPayment } from '../api/paymentsApi'
import type { BlockingSubscriptionPaymentResponse } from '../api/types'

export const BLOCKING_SUBSCRIPTION_QUERY_KEY = ['blocking-subscription'] as const

/**
 * Платёж, блокирующий покупку подписки (автоплатёж в ожидании проведения).
 * 404 бэка маппится в null на уровне API, поэтому здесь data === null
 * означает «блокировки нет», а ошибка — только реальный сбой запроса.
 * @returns {object} Результат react-query с data: платёж | null
 */
export const useBlockingSubscriptionQuery = (enabled = true) => {
  return useQuery<BlockingSubscriptionPaymentResponse | null>(
    BLOCKING_SUBSCRIPTION_QUERY_KEY,
    getBlockingSubscriptionPayment,
    { enabled, retry: 1 }
  )
}
